import { Map } from 'immutable';
import { VIEW_MODE } from '../../consts';

export const DEFAULT_BASE_FILTER = new Map({
  viewMode: VIEW_MODE.grid,     // режим просмотра
  bounds: null,                 // область карты,
  areaPolygon: null,            // выделеная область

  page: 1,                      // номер текущей страницы
  'per-page': 50,               // кол-во объектов на странице

  userId: null,                 // объявления пользователя | мои объекты
  agencyId: null,               // id агенства
  objectTypeId: null,           // тип недвижимости

  houseId: null,                // id дома
  streetId: null,               // Id улицы
  localityId: null,             // id населенного пункта
  address: null,                // текстовое представление адреса

  priceMax: null,               // цена от
  priceMin: null,               // цена до
  priceUnitId: null,            // тип цены - общая или за юнит (зависить от рубрики)

  district: null,               // район города
  microdistrict: null,          // микрорайоны города
  regionDistrict: null,         // район области
  subwayId: null,               // метро
  hideDuplicates: null,         // скрыть дубли
  sort: null,                   // сортировка
  interval: null,               // когда разместили: за сегодня, за последние сутки

  isMls: null,                  // мультилистинг,
  dataSourceId: null,           // источник данных: xml/приложение
  isDealCompleted: null,        // сделка завершена
  excludeVirtual: null          // исключать объявления от виртуальных аккаунтов: 0 - не исключать, 1 - исключать
});

export const DEFAULT_EXTEND_FILTER = new Map({
  onlyOwners: null,             // частные объявления | без комиссии
  onlyFromBuilder: null,        // только от застройщика
  deadlineId: null,             // срок сдачи новостройки
  squareTotalMin: null,         // min общая площадь квартиры
  squareTotalMax: null,         // max общая площадь квартиры
  squareLivingMin: null,        // min жилая площадь
  squareLivingMax: null,        // max жилая площадь
  squareKitchenMin: null,       // min площадь кухни
  squareKitchenMax: null,       // max площадь кухни
  squareLandMin: null,          // min площадь участка
  squareLandMax: null,          // max площадь участка
  floorMin: null,               // min этаж квартиры
  floorMax: null,               // max этаж квартиры
  floorTotalMin: null,          // дом не ниже
  distanceFromCityMin: null,    // min удаленность от города
  distanceFromCityMax: null,    // max удаленность от города
  builtYearMin: null,           // min год постройки дома
  builtYearMax: null,           // max год постройки дома
  numberOfBedsMin: null,        // min Кол-во спальных мест
  numberOfBedsMax: null,        // max Кол-во спальных мест

  sourceAppId: null,            // тип приложения: андроид, айфон и тд
  floorPositionId: null,        // не крайний, не первый ...
  planningId: null,             // планировка
  sanitaryId: null,             // санузел
  renovationTypeId: null,       // состояние/ремонт
  windowTypeId: null,           // окна
  windowViewId: null,           // вид из окна
  buildingTypeId: null,         // тип дома
  materialId: null,             // материал дома
  usageCategoryId: null,        // категория использования
  rentPeriodId: null,           // Период сдачи в аренду
  heatingId: null,              // вид отопления
  furnitureId: null,            // мебель
  tenantGenderPreferenceId: null, // предпочтение к жильцам
  tenantCountPreferenceId: null,  // Количество человек
  residentialComplexId: null,   // Жилой комплекс

  isCorner: null,               // расположение (угловая или нет)
  isResale: null,               // вторичка
  isNewBuilding: null,          // новостройки
  isMortgageAvailable: null,    // ипотека
  isClearSale: null,            // чистая продажа
  isExchange: null,             // обменный вариант
  isFirstLine: null,            // первая линия
  isDetachedBuilding: null,     // отдельно стоящее здание
  isChildrenAllowed: null,      // можно с детьми
  isAnimalsAllowed: null,       // можно с животными

  hasSecurityProtection: null,  // наличие охраны
  hasRepairPit: null,           // смотровая яма
  hasCellar: null,              // погреб
  hasElectricity: null,         // электричество
  hasHeating: null,             // отопление
  hasWater: null,               // водоснабжение
  hasCanalization: null,        // канализация
  hasGas: null,                 // газ
  hasGarage: null,              // гараж
  hasBathhouse: null,           // баня
  hasOutbuildings: null,        // хоз. постройки
  hasFridge: null,              // холодильник
  hasBalcony: null,             // есть балкон/лоджия?
  hasTV: null,                  // тв
  hasWashingMachine: null,      // стир машина
  hasConditioning: null,        // кондер
  hasInternet: null,            // интернет
  hasPhoto: null,               // с фото

  withoutComplaint: null,       // без жалоб
  ownEntrance: null,            // отдельный вход
  needDeposit: null,            // депозит
  includedUtilities: null,      // коммунальные услуги входят в стоимость аренды
  description: null,            // ключевые слова
  contactPhone: null,           // контактный телефон
  id: null,                     // id объявления
  agencyId: null,               // id агенства
  isMls: null,                  // мультилистинг
});

export const DEFAULT_FILTER = DEFAULT_BASE_FILTER.merge(DEFAULT_EXTEND_FILTER);



// WEBPACK FOOTER //
// ./src/app/Search/filter.js